import React, { useEffect, useMemo, useState } from 'react'
import { CloudUploadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Button, Card, Col, Form, Input, Tabs, Typography } from 'antd'
import { useMyContext } from 'Context/MyContextProvider';
const { Text } = Typography;

const CardData = (props) => {
    const { cardData, handleTabChange, buttonStyle, showMediaModel, handleMediaLinkChange, cardButtonValues, handleUrlButtonChange, setCardButtonValues } = props
    const { CheckExpiredMedia } = useMyContext()
    const [expiredMediaStatus, setExpiredMediaStatus] = useState({});
    const renderUrlButtonFields = (card, cardIndex) => {
        if (!card.buttons || !card.buttons.buttons || card.buttons.buttons.length === 0) {
            return null;
        }

        const urlButtons = card.buttons.buttons.filter(button => button.type === "URL");
        // if url button contains example key in then only show field
        if (urlButtons.length === 0 || !urlButtons.some(button => button.hasOwnProperty('example'))) {
            return null;
        }
        if (urlButtons.length === 0) {
            return null;
        }
        //console.log(urlButtons, 'urlButtons');
        return (
            <div className="mt-3">
                {/* <h4>URL Button Values</h4> */}
                {urlButtons.map((button, buttonIndex) => (
                    <Form.Item
                        key={buttonIndex}
                        label={`${button.text || `Button ${buttonIndex + 1}`} URL Value`}
                        rules={[{ required: true, message: `Please enter a URL for ${button.text || `Button ${buttonIndex + 1}`}` }]}
                    >
                        <Input
                            placeholder="Enter URL value"
                            value={cardButtonValues[`${cardIndex}_${buttonIndex}`] || ''}
                            onChange={(e) => handleUrlButtonChange(cardIndex, buttonIndex, e.target.value, setCardButtonValues)}
                        />
                        <small>{button.url}</small>
                    </Form.Item>
                ))}
            </div>
        );
    };
    // Check expired media status when cardData changes
    useEffect(() => {
        const checkAllMediaStatus = async () => {
            const statusMap = {};

            for (let cardIndex = 0; cardIndex < cardData.length; cardIndex++) {
                const card = cardData[cardIndex];
                if (card.mediaLink) {
                    try {
                        const isExpired = await CheckExpiredMedia(card.mediaLink);
                        statusMap[`${cardIndex}_${card.mediaLink}`] = (!isExpired);
                    } catch (error) {
                        statusMap[`${cardIndex}_${card.mediaLink}`] = false;
                    }
                }
            }

            setExpiredMediaStatus(statusMap);
        };

        if (cardData.length > 0) {
            checkAllMediaStatus();
        }
    }, [cardData, CheckExpiredMedia]);

    // Memoized function to get expired status
    const isMediaExpired = useMemo(() => {
        return (cardIndex, mediaLink) => {
            if (!mediaLink) return false;
            return expiredMediaStatus[`${cardIndex}_${mediaLink}`] || false;
        };
    }, [expiredMediaStatus]);
    return (
        <>
            {cardData.length > 0 && (
                <Col span={24}>
                    <Card title={`Total Cards : ${cardData?.length}`} style={{ width: '100%' }}>
                        <Tabs
                            defaultActiveKey="0"
                            type="card"
                            onChange={handleTabChange}
                            items={
                                cardData.map((card, cardIndex) => ({
                                    key: String(cardIndex),
                                    label: (
                                        `Card ${cardIndex + 1}`
                                    ),
                                    children: (
                                        <Card bordered={false} style={{ height: '100%' }}>
                                            <p>Card {cardIndex + 1} Body  : {card?.body?.text}</p>
                                            {card.mediaType === 'Media' ? (
                                                <Form.Item
                                                    label={`Select Media File For Card ${cardIndex + 1}`}
                                                    name={`media-link-${cardIndex}`}
                                                >
                                                    {!card.mediaLink ? (
                                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                            <Button
                                                                style={buttonStyle}
                                                                onClick={() => showMediaModel(cardIndex)}
                                                            >
                                                                <CloudUploadOutlined /> Choose File
                                                            </Button>
                                                            <Alert
                                                                message={
                                                                    <Text>
                                                                        Please select <Text strong>
                                                                            {card.header?.format?.toLowerCase() || 'media'}
                                                                        </Text> to continue
                                                                    </Text>
                                                                }
                                                                type="info"
                                                                showIcon
                                                                icon={<InfoCircleOutlined />}
                                                                style={{
                                                                    fontSize: '13px',
                                                                    backgroundColor: '#f6ffed',
                                                                    border: '1px solid #b7eb8f',
                                                                    flex: 1
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                                            <Input
                                                                type="text"
                                                                disabled
                                                                value={card.mediaLink}
                                                                style={{ flex: '1 1 300px', minWidth: '200px' }}
                                                            />
                                                            <Button
                                                                style={buttonStyle}
                                                                onClick={() => showMediaModel(cardIndex)}
                                                            >
                                                                <CloudUploadOutlined /> Choose Another File
                                                            </Button>
                                                            <Alert
                                                                message={
                                                                    <Text>
                                                                        File selected: <Text strong>
                                                                            {card.header?.format?.toLowerCase() || 'media'}
                                                                        </Text>
                                                                    </Text>
                                                                }
                                                                type="success"
                                                                showIcon
                                                                style={{
                                                                    fontSize: '12px',
                                                                    flex: '1 1 200px',
                                                                    minWidth: '180px'
                                                                }}
                                                            />
                                                        </div>
                                                    )}

                                                    {card.mediaLink && isMediaExpired(cardIndex, card.mediaLink) && (
                                                        <Alert
                                                            message={
                                                                <Text>Media Expired. Please select new one.</Text>
                                                            }
                                                            type="warning"
                                                            showIcon
                                                            className='mt-2'
                                                            icon={<InfoCircleOutlined />}
                                                        />
                                                    )}
                                                </Form.Item>
                                            ) : (
                                                <Form.Item
                                                    label="Your media file link"
                                                    name={`media-link-${cardIndex}`}
                                                    rules={[
                                                        { required: true, message: 'Please enter a media link!' }
                                                    ]}
                                                >
                                                    <Input
                                                        type="text"
                                                        onChange={(e) =>
                                                            handleMediaLinkChange(e.target.value, cardIndex)
                                                        }
                                                        className="mb-3"
                                                    />
                                                </Form.Item>
                                            )}
                                            {card.inputs?.length > 0 && (
                                                <Form.Item label={`${card.inputs.length} dynamic values detected`}>
                                                    {card.inputs}
                                                </Form.Item>
                                            )}

                                            {/* Render URL button fields */}
                                            {renderUrlButtonFields(card, cardIndex)}
                                        </Card>
                                    ),
                                }))}
                        />
                    </Card>
                </Col>
            )}
        </>
    )
}

export default CardData
